import React from 'react';
import {layout, CardItems, ScrollableCard} from 'mc/lib';
import {Row, Col, Container} from 'reactstrap';
import * as parovaniActions from "../actions/ParovaniActions";
import {connect} from "react-redux";
import {storeFromArea} from "mc/lib/utils/index";
import ParovaniPlatebForm from '../forms/ParovaniPlatebForm';
import ParovaniPlatebRow from '../components/ParovaniPlatebRow';
import {toastr} from 'react-redux-toastr'

import "./ParovaniPlatebPage.scss";

/**
 * Stránka pro vyhledávání plateb.
 */

class ParovaniPlatebPage extends React.Component {

    state = {
        bankovniUcet: null
    };

    componentDidMount() {
        this.fetchData(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.fetchData(nextProps, false);
    }

    fetchData = (props, forceFetch = false) => {
        if (props.platby.filter && Object.keys(props.platby.filter).length > 0) {
            props.dispatch(parovaniActions.fetchPlatbyIfNeeded(forceFetch));
        }

        // const kodTypPripad = this.getKodTypPripad(props);
        // props.dispatch(parovaniActions.fetchBankovniUctyIfNeeded(kodTypPripad, forceFetch));
    };

    getKodTypPripad = (props) => {
        const {match: {params: {kodTypPripad}}} = props;
        return kodTypPripad;
    };

    // handleBankovniUcetChange = bankovniUcet => {
    //     this.setState({bankovniUcet: bankovniUcet});
    //
    //     this.props.dispatch(parovaniActions.fetchPlatbyIfNeeded(filter, true));
    // };

    handleHledat = (filter) => {
        const kodTypPripad = this.getKodTypPripad(this.props);
        // const {bankovniUcet} = this.state;

        this.props.dispatch(parovaniActions.filterPlatby({...filter, kodTypPripad}));
    };

    render() {
        const kodTypPripad = this.getKodTypPripad(this.props);
        const {bankovniUcty, platby} = this.props;
        // const {bankovniUcet} = this.state;

        let content;
        let showPlatby = platby && platby.fetched;

        if (!kodTypPripad || kodTypPripad === "") {
            content = <h3>Nebyl předám kód typu případu.</h3>;
        }/* else if (!bankovniUcty || !bankovniUcty.fetched) {
            content = <Loader />;
        } else if (bankovniUcty.fetched && bankovniUcty.rows.length === 0) {
            content = <layout.PageContent><h3>Není dostupný žádný bankovní účet.</h3></layout.PageContent>;
        }*/ else {
            content = <Container fluid>
                <Row className="align-content-start h-100">
                    <Col xs="12">
                        <h3 className="font-weight-bold">Vyhledávání plateb</h3>
                    </Col>
                    {/*<FixedDropDownButton className="link-inline" caret title={bankovniUcet ? ('na účtu ' + fakUtils.formatCisloUctu(bankovniUcet)) : 'Vybrat účet'}>*/}
                    {/*{bankovniUcty.rows.map(u => {*/}
                    {/*return <DropdownItem key={u} onClick={() => this.handleBankovniUcetChange(u)}>{fakUtils.formatCisloUctu(u)}</DropdownItem>*/}
                    {/*})}*/}
                    {/*</FixedDropDownButton>*/}
                    <Col xs="12">
                        <ParovaniPlatebForm onSubmit={this.handleHledat}/>
                    </Col>
                    <Col xs="12" className="h-100">
                        {!showPlatby &&
                        <h3 className="text-center p-5">Pro nalezení plateb zadejte vyhledávací podmínku a potvrďte
                            tlačítkem Hledat.</h3>}

                        {showPlatby &&
                        <div className="items-list-header">{'Počet nalezených položek: ' + platby.rows.length}</div>}
                        {showPlatby && <ScrollableCard className="h-100">
                            <CardItems bordered>{platby.rows.map(platba => <ParovaniPlatebRow
                                platba={platba} kodTypPripad={kodTypPripad}/>)}</CardItems>
                        </ScrollableCard>}
                    </Col>
                </Row>
            </Container>;
        }

        return <layout.PageWrapper>
            <layout.PageContent>{content}</layout.PageContent>
        </layout.PageWrapper>;
    }
}

export default connect((state, props) => {
    return {
        bankovniUcty: storeFromArea(state, parovaniActions.BANKOVNI_UCTY_LIST_AREA),
        platby: storeFromArea(state, parovaniActions.PLATBY_LIST_AREA)
    }
})(ParovaniPlatebPage);
